<!--
 * @Author: 李明明
 * @Date: 2022-09-20 11:20:13
 * @LastEditTime: 2022-12-06 14:27:58
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/views/courseDetail/components/test.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <div class="test_wrap">
    <!-- 随堂测试成功率弹窗 -->
    <el-dialog
      class="rate_dialog"
      :show-close="false"
      :model-value="rate"
      width="440px"
      center
    >
      <div
        class="rate_center"
        :style="{ backgroundImage: 'url(' + rateBg + ')' }"
      >
        <p class="rate_title">随堂小考</p>
        <div class="rate_data">
          <span>{{ rateTxt }}</span>
          <div class="rate_tip">
            <p class="pre">%</p>
            <p class="acc">正确率</p>
          </div>
        </div>
      </div>
      <div class="rate_bottom">本次测试已结束！关闭本窗口继续学习。</div>
      <i class="iconfont iconguanbi" @click="closeRate"></i>
    </el-dialog>
    <!-- 随堂测试答题弹窗 -->
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="随堂小考"
      :model-value="testShow"
      width="860px"
      center
    >
      <!-- 问题区 -->

      <!-- 该问题已经回答过 -->
      <template v-if="anchor_list.anchorShow">
        <!-- 单选 -->
        <div class="test_center reply" v-if="anchor_list.examQuestionType == 1">
          <p class="test_title">
            <span>单选</span>
            {{ anchor_list.examQuestionName }}
          </p>
          <ul class="test_content">
            <template
              v-for="(item, index) in anchor_list.optionList"
              :key="index"
            >
              <li
                class="reply_list"
                v-if="item.anchor_user_answer == 1"
                style="background: rgb(213, 227, 254, 0.4)"
              >
                <p>{{ item.optionNumber }}、{{ item.optionName }}</p>
              </li>
              <li class="reply_list" v-else>
                <p>{{ item.optionNumber }}、{{ item.optionName }}</p>
              </li>
            </template>
          </ul>
          <!-- 用户答对 -->
          <img
            v-if="anchor_list.anchor_answer_is_true"
            src="@/assets/images/testRight.png"
            alt=""
            class="right_pic"
          />
          <img
            v-else
            src="@/assets/images/testError.png"
            alt=""
            class="right_pic"
          />
        </div>
        <!-- 多选 -->
        <div class="test_center reply" v-if="anchor_list.examQuestionType == 2">
          <p class="test_title">
            <span>多选</span>
            {{ anchor_list.examQuestionName }}
          </p>
          <ul class="test_content">
            <template
              v-for="(item, index) in anchor_list.optionList"
              :key="index"
            >
              <li
                class="reply_list"
                v-if="item.anchor_user_answer == 1"
                style="background: rgb(213, 227, 254, 0.4)"
              >
                <p>{{ item.optionNumber }}、{{ item.optionName }}</p>
              </li>
              <li class="reply_list" v-else>
                <p>{{ item.optionNumber }}、{{ item.optionName }}</p>
              </li>
            </template>
          </ul>
          <!-- 用户答对 -->
          <img
            v-if="anchor_list.anchor_answer_is_true"
            src="@/assets/images/testRight.png"
            alt=""
            class="right_pic"
          />
          <img
            v-else
            src="@/assets/images/testError.png"
            alt=""
            class="right_pic"
          />
        </div>
        <!-- 判断 -->
        <div class="test_center reply" v-if="anchor_list.examQuestionType == 3">
          <p class="test_title">
            <span>判断</span>
            {{ anchor_list.examQuestionName }}
          </p>
          <ul class="test_content">
            <template
              v-for="(item, index) in anchor_list.optionList"
              :key="index"
            >
              <li
                class="reply_list"
                v-if="item.anchor_user_answer == 1"
                style="background: rgb(213, 227, 254, 0.4)"
              >
                <p>{{ item.optionNumber }}、{{ item.optionName }}</p>
              </li>
              <li class="reply_list" v-else>
                <p>{{ item.optionNumber }}、{{ item.optionName }}</p>
              </li>
            </template>
          </ul>
          <!-- 用户答对 -->
          <img
            v-if="anchor_list.anchor_answer_is_true"
            src="@/assets/images/testRight.png"
            alt=""
            class="right_pic"
          />
          <img
            v-else
            src="@/assets/images/testError.png"
            alt=""
            class="right_pic"
          />
        </div>
        <p v-if="anchor_list.examQuestionType == 2" class="right_txt">
          正确答案：{{ anchor_list.examQuestionCorrectAnswer }}
        </p>
        <p v-else class="right_txt">
          正确答案：{{ anchor_list.examQuestionCorrectAnswer }}
        </p>
      </template>
      <!-- 该问题没有回答过 -->
      <template v-else>
        <!-- 单选 -->
        <div class="test_center" v-if="anchor_list.examQuestionType == 1">
          <p class="test_title">
            <span>单选</span>
            {{ anchor_list.examQuestionName }}
          </p>
          <div class="test_content">
            <el-radio-group v-model="radio" class="test_list_group">
              <el-radio
                class="test_list"
                :label="item.optionNumber"
                v-for="(item, index) in anchor_list.optionList"
                :key="index"
                >{{ item.optionNumber }}、{{ item.optionName }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <!-- 多选 -->
        <div class="test_center" v-if="anchor_list.examQuestionType == 2">
          <p class="test_title">
            <span>多选</span>
            {{ anchor_list.examQuestionName }}
          </p>
          <div class="test_content">
            <el-checkbox-group v-model="checkArr" class="test_list_group">
              <el-checkbox
                class="test_list"
                :label="item.optionNumber"
                v-for="(item, index) in anchor_list.optionList"
                :key="index"
                >{{ item.optionNumber }}、{{ item.optionName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <!-- 判断 -->
        <div class="test_center" v-if="anchor_list.examQuestionType == 3">
          <p class="test_title">
            <span>判断</span>
            {{ anchor_list.examQuestionName }}
          </p>
          <div class="test_content">
            <el-radio-group v-model="radio" class="test_list_group">
              <el-radio
                class="test_list"
                :label="item.optionNumber"
                v-for="(item, index) in anchor_list.optionList"
                :key="index"
                >{{ item.optionNumber }}、{{ item.optionName }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </template>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="sign()">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { ref, watch, onMounted } from "vue";
import * as courseApi from "@/api/course";
import { useRoute } from "vue-router";
const route = useRoute();

const rate = ref(false);
const emit = defineEmits();
const props = defineProps({
  anchor_list: Object,
  currentVideoData: Object,
  testShow: Boolean,
});

const radio = ref("");
const checkArr = ref([]);
const rightTxt = ref(false);
const signUpUserId = ref("");
const onlineClassId = ref("");

watch(
  () => props.anchor_list,
  (val, val2) => {
    // 用户已经回答过该问题
    rightTxt.value = false;
    radio.value = "";
    checkArr.value = [];
  },
  { deep: true, immediate: true }
);

// 回答随堂考
const sign = () => {
  if (props.anchor_list.anchorShow == false) {
    if (
      props.anchor_list.examQuestionType == 1 ||
      props.anchor_list.examQuestionType == 3
    ) {
      if (radio.value == "") {
        ElMessage({
          customClass: "messageIndex",
          message: "请选择一个答案后再提交",
          type: "warning",
        });
      } else {
        AsyncOnlineAnswer(1);
      }
    } else {
      if (checkArr.value.length == 0) {
        ElMessage({
          customClass: "messageIndex",
          message: "请最少选择一个答案后再提交",
          type: "warning",
        });
      } else {
        AsyncOnlineAnswer(2);
      }
    }
  } else {
    emit("sign", props.anchor_list.isAnswer);
    props.anchor_list.isAnswer = 1;
  }
};

// 请求回答锚点接口
const AsyncOnlineAnswer = (type) => {
  let params = {};
  if (type == 1) {
    params = {
      signUpUserId: signUpUserId.value,
      onlineClassId: onlineClassId.value,
      anchorId: props.anchor_list.anchorId,
      questionId: props.anchor_list.examQuestionId,
      userAnswer: radio.value,
      onlineColumnId: props.currentVideoData.onlineColumnId,
      onlineDataId: props.currentVideoData.onlineDataId,
    };
  } else {
    let checkPut = checkArr.value.sort().join(",");
    params = {
      signUpUserId: signUpUserId.value,
      onlineClassId: onlineClassId.value,
      anchorId: props.anchor_list.anchorId,
      questionId: props.anchor_list.examQuestionId,
      userAnswer: checkPut,
      onlineColumnId: props.currentVideoData.onlineColumnId,
      onlineDataId: props.currentVideoData.onlineDataId,
    };
  }
  courseApi.onlineAnswer(params).then((res) => {
    if (res.resCode == 200) {
      ElMessage({
        customClass: "messageIndex",
        message: "随堂测试提交成功",
        type: "success",
      });
      props.anchor_list.anchorShow = true;
      props.anchor_list.anchor_answer_is_true = res.resData.anchorAnswerIsTrue;
      if (
        props.anchor_list.examQuestionType == 1 ||
        props.anchor_list.examQuestionType == 3
      ) {
        props.anchor_list.anchor_user_answer = radio.value;
        props.anchor_list.right_answer = res.resData.correctAnswer;
        props.anchor_list.optionList.forEach((item) => {
          // // 用户是否选择该选项
          if (radio.value == item.optionNumber) {
            item.anchor_user_answer = 1;
          } else {
            item.anchor_user_answer = 0;
          }
          // 该选项是否为正确选项
          if (res.resData.correctAnswer == item.optionNumber) {
            item.right_answer = 1;
          } else {
            item.right_answer = 0;
          }
        });
      } else {
        props.anchor_list.anchor_user_answer = checkArr.value;
        props.anchor_list.right_answer = res.resData.correctAnswer;
        let anchor_user_answer = checkArr.value; // 用户选择的选项数组
        let right_answer = res.resData.correctAnswer.split(","); // 正确答案数组
        props.anchor_list.optionList.forEach((item) => {
          // 遍历用户已选择的数组
          anchor_user_answer.forEach((items) => {
            // 用户已选的选项增加已选属性
            if (items == item.optionNumber) {
              item.anchor_user_answer = 1;
            }
          });

          // 遍历正确答案数组
          right_answer.forEach((items) => {
            // 正确答案的选项增加正确属性
            if (items == item.optionNumber) {
              item.right_answer = 1;
            }
          });
        });
      }
      props.anchor_list.examQuestionCorrectAnswer = res.resData.correctAnswer;
      rightTxt.value = true;
      console.log(res.resData);
      if (
        res.resData.exam_question_type == 1 ||
        res.resData.exam_question_type == 3
      ) {
        radio.value = res.resData.correctAnswer;
      } else {
        checkArr.value = res.resData.correctAnswer.split(",");
      }
    }
  });
};

onMounted(() => {
  signUpUserId.value = route.query.signUpUserId;
  onlineClassId.value = route.query.onlineClassId;
});
</script>

<style lang="scss">
.messageIndex {
  z-index: 999999999999 !important;
}
.test_wrap {
  height: 100%;

  .rate_dialog {
    .el-dialog {
      border-radius: 21px;

      .el-dialog__header {
        display: none;
      }

      .el-dialog__body {
        padding: 0;

        .rate_center {
          position: relative;
          width: 100%;
          height: 290px;
          background-size: cover;
          overflow: hidden;

          .rate_title {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2.4px;
            color: #fefefe;
            text-align: center;
            margin-top: 54px;
          }

          .rate_data {
            text-align: center;
            margin-top: 60px;

            span {
              display: inline-block;
              font-size: 70px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 42.7px;
              letter-spacing: 4px;
              color: #ffffff;
              vertical-align: top;
            }

            .rate_tip {
              display: inline-block;
              text-align: left;
              vertical-align: top;

              .pre {
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 3px;
                color: #ffffff;
              }

              .acc {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 2.3px;
                color: #ffffff;
                padding: 3px 6px;
                background: #ff9f2d;
                border-radius: 3px;
                margin-top: 8px;
              }
            }
          }
        }

        .rate_bottom {
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 80px;
          letter-spacing: 0px;
          color: #bebebe;
          text-align: center;
        }

        .iconguanbi {
          position: absolute;
          bottom: -60px;
          font-size: 30px;
          left: 0;
          right: 0;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }

  .test_title {
    font-size: 14px;
    line-height: 30px;

    span {
      font-size: 14px;
      font-stretch: normal;
      letter-spacing: 1.8px;
      color: #de3031;
      border-radius: 5px;
      border: 1px solid #df30df;
      padding: 0px 5px;
    }
  }

  .reply {
    .reply_list {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 60px;
      letter-spacing: 0px;
      color: #2f2f2f;
      padding: 0 20px;
      margin-top: 20px;
      display: block;

      p {
        display: inline-block;
        width: 710px;
        padding-right: 20px;
        vertical-align: middle;
      }

      i {
        font-size: 16px;
        color: #a2a1a1;
        vertical-align: middle;
      }
    }
  }

  .test_center {
    .test_content {
      border-top: 1px solid #e5e5e5;
      margin-top: 20px;
      height: 300px;
      overflow-y: auto;
      position: relative;
      z-index: 2;

      .test_list_group {
        width: 100%;

        .test_list {
          display: block;
          width: 100%;
          margin: 20px auto 0 auto;
          min-height: 40px;
          height: auto;
          &:hover {
            background: #d5e3fe;
          }

          span {
            line-height: 40px;
          }

          .el-radio__input {
            float: right;
            vertical-align: middle;
            margin-right: 10px;
            margin-top: 12px;
          }

          .el-radio__label {
            width: 720px;
            display: inline-block;
            white-space: pre-wrap;
          }

          .el-checkbox__input {
            float: right;
            vertical-align: middle;
            margin-right: 10px;
            margin-top: 12px;
          }

          .el-checkbox__label {
            width: 720px;
            display: inline-block;
            white-space: pre-wrap;
          }
        }
      }
    }

    .right_pic {
      width: 200px;
      position: absolute;
      top: 200px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }

  .right_txt {
    text-align: center;
    margin-top: 40px;
    color: #57bb4f;
    font-size: 16px;
  }
}
</style>
